var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "subscriber" }, [
    _c(
      "div",
      { staticClass: "subscriber-channels" },
      [
        !!_vm.subscriber.id && _vm.subscriber.id.length > 0
          ? [
              _c(
                "div",
                {
                  staticClass: "subscriber-channel-entry",
                  class: _vm.checked ? "active" : "",
                },
                [
                  _c("channel-icon", {
                    attrs: {
                      "read-only": "",
                      "channel-data": _vm.subscriber.channel,
                    },
                  }),
                  _c("div", { staticClass: "subscriber-channel-entry__name" }, [
                    _vm._v(" " + _vm._s(_vm.subscriber.channel.label) + " "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "subscriber-channel-entry__description" },
                    [_vm._v(" " + _vm._s(_vm.subscriber.description) + " ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "subscriber-channel-entry__actions" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _vm.actionEdit === true
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  rounded: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.editChannelHandler(
                                                      _vm.subscriber
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v(" far fa-edit ")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.actionAssign === true
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  rounded: "",
                                                },
                                                on: {
                                                  click:
                                                    _vm.assignChannelHandler,
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [
                                                _vm._v(
                                                  " fas " +
                                                    _vm._s(
                                                      _vm.checked
                                                        ? "fa-link"
                                                        : "fa-unlink"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1625017152
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                `${
                                  _vm.actionEdit === true
                                    ? "Edit"
                                    : _vm.checked
                                    ? "Remove"
                                    : "Add"
                                } channel`
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _vm.actionEdit === true
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  rounded: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteChannelHandler(
                                                      _vm.subscriber
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { "x-small": "" } },
                                              [_vm._v(" fas fa-trash ")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            114453885
                          ),
                        },
                        [_c("span", [_vm._v("Delete channel")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          : [
              _c("div", { staticClass: "no-results" }, [
                _vm._v("Tenant has no assigned subscription channels."),
              ]),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }